// extracted by mini-css-extract-plugin
export default {"container":"CookieSettings__container--2i7","list":"CookieSettings__list--3Uo","infoListItem":"CookieSettings__infoListItem--2AE"};